const state = {
  mIndustry: null,
  mMarketArea: null,
  mFavoriteIndustries: [],
  mFavoriteMarketAreas: [],
  mSearchInputIndustry: null,
  mSearchInputMarketArea: null,
  mSearchIndustries: [],
  mSearchMarketAreas: [],
  mSearchLoadingIndustry: false,
  mSearchLoadingMarketArea: false,
  mProfileId: 0,
  mModalMarketRadius: false,
  mSearchMarketCenterZip: null,
  mSearchMarketCenter: null,
  mSearchMarketRadius: null,
};

const mutations = {
  M_SET_INDUSTRY: (state, mIndustry) => {
    state.mIndustry = mIndustry;
  },
  M_SET_MARKET_AREA: (state, mMarketArea) => {
    state.mMarketArea = mMarketArea;
  },
  M_SET_PROFILE_ID: (state, mProfileId) => {
    state.mProfileId = mProfileId;
  },
  M_SET_FAVORITE_INDUSTRIES: (state, mIndustry) => {
    state.mFavoriteIndustries = mIndustry;
  },
  M_SET_FAVORITE_MARKET_AREAS: (state, mMarketArea) => {
    state.mFavoriteMarketAreas = mMarketArea;
  },
  M_SET_SEARCH_INPUT_INDUSTRY: (state, mSearchInputIndustry) => {
    state.mSearchInputIndustry = mSearchInputIndustry;
  },
  M_SET_SEARCH_INPUT_MARKET_AREA: (state, mSearchInputMarketArea) => {
    state.mSearchInputMarketArea = mSearchInputMarketArea;
  },
  M_SET_SEARCH_INDUSTRIES: (state, mSearchIndustries) => {
    state.mSearchIndustries = mSearchIndustries;
  },
  M_SET_SEARCH_MARKET_AREAS: (state, mSearchMarketAreas) => {
    state.mSearchMarketAreas = mSearchMarketAreas;
  },
  M_SET_SEARCH_LOADING_INDUSTRY: (state, mSearchLoadingIndustry) => {
    state.mSearchLoadingIndustry = mSearchLoadingIndustry;
  },
  M_SET_SEARCH_LOADING_MARKET_AREA: (state, mSearchLoadingMarketArea) => {
    state.mSearchLoadingMarketArea = mSearchLoadingMarketArea;
  },
  M_PUSH_TO_FAVORITE_INDUSTRIES: (state, mIndustry) => {
    state.mFavoriteIndustries.push(mIndustry);
  },
  M_PUSH_TO_FAVORITE_MARKET_AREAS: (state, mMarketArea) => {
    state.mFavoriteMarketAreas.push(mMarketArea);
  },

  M_SET_MODAL_MARKET_RADIUS: (state,mModalMarketRadius) => {
    state.mModalMarketRadius = mModalMarketRadius;
  },
  
  M_SET_SEARCH_MARKET_RADIUS: (state,mSearchMarketRadius) => {
    state.mSearchMarketRadius = mSearchMarketRadius;
  },

  M_SET_SEARCH_MARKET_CENTER: (state,mSearchMarketCenter) => {
    state.mSearchMarketCenter = mSearchMarketCenter;
  },

  M_SET_SEARCH_MARKET_CENTER_ZIP: (state,mSearchMarketCenterZip) => {
    state.mSearchMarketCenterZip = mSearchMarketCenterZip;
  }
};

const getters = {
  mIndustry: (state) => state.mIndustry,
  mMarketArea: (state) => state.mMarketArea,
  mProfileId: (state) => state.mProfileId,
  mFavoriteIndustries: (state) => state.mFavoriteIndustries,
  mFavoriteMarketAreas: (state) => state.mFavoriteMarketAreas,
  mSearchInputIndustry: (state) => state.mSearchInputIndustry,
  mSearchInputMarketArea: (state) => state.mSearchInputMarketArea,
  mSearchIndustries: (state) => state.mSearchIndustries,
  mSearchMarketAreas: (state) => state.mSearchMarketAreas,
  mSearchLoadingIndustry: (state) => state.mSearchLoadingIndustry,
  mSearchLoadingMarketArea: (state) => state.mSearchLoadingMarketArea,
  mModalMarketRadius: (state) => state.mModalMarketRadius,
  mSearchMarketRadius: (state) => state.mSearchMarketRadius,
  mSearchMarketCenter:  (state) => state.mSearchMarketCenter,
  mSearchMarketCenterZip:  (state) => state.mSearchMarketCenterZip,
};

const marketSelection = {
  state,
  getters,
  mutations,
};

export default marketSelection;
